import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { TemplateTop5 } from '../template-top5.model';
import { TemplateService } from '../template.service';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'fnsr-template-top5',
  standalone: true,
  imports: [LoadComponent, AsyncPipe],
  templateUrl: './template-top5.component.html',
  styleUrls: ['./template-top5.component.scss']
})
export class TemplateTop5Component {
  templateListTop5$: Observable<TemplateTop5[]>;
  isVisible: boolean = true;

  constructor(private templateService: TemplateService,
  ) {
    this.templateListTop5$ = this.templateService.getTemplateListTop5();
  }

  hide() {
    this.isVisible = false;
  }
}
